import React from 'react';
import './ExperienceCredentialsScreen.css';

const ExperienceCredentialsScreen = ({ onNext, onBack, onDataUpdate, data }) => {
  return (
    <div className="experience-credentials-screen">
      <h1>Experience & Credentials</h1>
      <p>Coming soon...</p>
      <div className="form-actions">
        <button onClick={onBack} className="back-button">
          Back
        </button>
        <button onClick={onNext} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default ExperienceCredentialsScreen; 